module.exports = __webpack_public_path__ + "img/status.8640e4a8.gif";